module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_6_1.4bc30deb.png";